// Helper methods

import config from 'services/config'
import {
  checkIfSessionExists,
  handleUnsuccesfulResponse
} from 'services/helpers/authorizationHandlers'
import LocalUserService from 'services/localUserService'

const userService = new LocalUserService()

const getHeaders = () => ({
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache',
  'sp-auth': userService.getCurrentUserInfo()?.sessionId
})

const baseUrl = config.apiUrl + '/'

export async function get(url = ``) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'GET',
    headers: getHeaders()
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)

      return { data }
    })
}

export async function put(url = ``, data = {}) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)

      return { data }
    })
}

export async function postWithoutResponse(url = ``, data = {}) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
}

export async function post(url = ``, data = {}) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)

      return data
    })
}

export async function del(url = ``, data) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)

      return { data }
    })
}

export async function patch(url = ``, data = {}) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)

      return { data }
    })
}

export async function getFile(url = ``) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'GET',
    headers: getHeaders()
  })
    .then(res => {
      if (!res.ok) {
        throw new Error('Network response was not ok')
      }
      return res.blob()
    })
    .then(blob => {
      let file = window.URL.createObjectURL(blob)
      window.location.assign(file)
    })
}

export async function getText(url = ``) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'GET',
    headers: getHeaders()
  })
    .then(res => res.text())
    .then(data => {
      return { data }
    })
}

export async function putRaw(url = ``, data) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'PUT',
    headers: getHeaders(),
    body: data
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)
      return data
    })
}

export async function postRaw(url = ``, data) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'POST',
    headers: getHeaders(),
    body: data
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)
      return data
    })
}

export async function postTextResponse(url = ``, data) {
  checkIfSessionExists()

  return fetch(baseUrl + url, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  }).then(res => res.text())
}

export async function getWithoutSession(url = ``) {
  return fetch(baseUrl + url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    }
  }).then(res => res.json())
}

export async function postWithoutSession(url = ``, data = {}) {
  return fetch(baseUrl + url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    },
    body: JSON.stringify(data)
  }).then(res => res.json())
}

export async function getWithWrongSession(url = ``) {
  // for debug purposes

  return fetch(baseUrl + url, {
    method: 'GET',
    headers: {
      ...getHeaders(),
      'sp-auth': 'sp_session_eeab55aa-ceea-4567-aa08-d5f6a9660236'
    }
  })
    .then(res => res.json())
    .then(data => {
      handleUnsuccesfulResponse(data, url)

      return { data }
    })
}
